import { type Brand, make } from "ts-brand";
import { z } from "zod";

/**
 * Nominal IDs via ts-brand — the compiler rejects mixing one aggregate's ID
 * with another's. The walking skeleton ships one (`RequestId`) to prove the
 * pattern; the full set (`MandateId`, `DocumentId`, …) lands with the domain
 * model in Phase 1+ (see docs/architecture.md § "Shared domain model").
 */
export type RequestId = Brand<string, "RequestId">;
export const RequestId = make<RequestId>();

/**
 * Zod baseline — boundary validation lives in `shared` so client and server
 * validate identically. `PingResponseSchema` is the contract for the
 * skeleton's only service function.
 */
export const PingResponseSchema = z.object({
    version: z.string(),
    message: z.string(),
});

export type PingResponse = z.infer<typeof PingResponseSchema>;
